<template>
  <div class="flex">
    <h3 class="sub-title">{{ $t('patient.ophthalmicDiseases') }}</h3>
    <div class="form-check">
      <BaseSquareCheckBox id="diabeticRetinopathy" :item="'diabeticRetinopathy'" @checked="doCheck"/>
      <label class="form-check-label" for="diabeticRetinopathy">
        {{ $t('disease.diabeticRetinopathy') }}
      </label>
    </div>
    <div class="form-check">
      <BaseSquareCheckBox id="dmri" :item="'dmri'" @checked="doCheck"/>
      <label class="form-check-label" for="dmri">
        {{ $t('disease.amd') }}
      </label>
    </div>
    <div class="form-check">
      <BaseSquareCheckBox id="glaucoma" :item="'glaucoma'" @checked="doCheck"/>
      <label class="form-check-label" for="glaucoma">
        {{ $t('disease.glaucoma') }}
      </label>
    </div>
    <div class="form-check">
      <BaseSquareCheckBox id="cataract" :item="'cataract'" @checked="doCheck"/>
      <label class="form-check-label" for="cataract">
        {{ $t('disease.cataract') }}
      </label>
    </div>
    <div class="form-check">
      <BaseSquareCheckBox id="pterygium" :item="'pterygium'" @checked="doCheck"/>
      <label class="form-check-label" for="pterygium">
        {{ $t('disease.pterygium') }}
      </label>
    </div>
    <div class="form-check">
      <BaseSquareCheckBox id="lowVisualAcuity" :item="'lowVisualAcuity'" @checked="doCheck"/>
      <label class="form-check-label" for="lowVisualAcuity">
        {{ $t('disease.lowVisualAcuity') }}
      </label>
    </div>
    <div class="form-check">
      <BaseSquareCheckBox id="nwn_ophthalmic" :item="'nwn_ophthalmic'" @checked="doCheck"/>
      <label class="form-check-label" for="nwn_ophthalmic">
        {{ $t('disease.nwn_ophthalmic') }}
      </label>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .flex {
    display:                 flex;
    flex-direction:          column;
    align-items:             flex-start;
    gap:                     15px;
    padding:                 20px 0;
  }

  .form-check {
    @include                 border_radius(5px);
    display:                 flex;
    flex-direction:          row;
    justify-content:         center;
    align-items:             center;
    gap:                     10px;
    align-self:              stretch;
    padding:                 0; // 8px 12px;
    // border:                  1px solid var(--Shades-30, #D8D8D8);
    border:                  unset;

    label {
      color:                 var(--Brand-Primary);
      font-size:             13px;
      font-weight:           400;
      line-height:           normal;
      letter-spacing:        1.95px;
      text-transform:        uppercase;
      margin:                0;
    }
  }
</style>

<script>
export default {
  name: 'PatientCreateOphthalmicDiseases',
  props: {
    ophthalmic: { type: Object, default: null },
  },
  data: () => ({
  }),
  mounted() {
    if (this.ophthalmic) {
      this.updateCheck()
    }
  },
  methods: {
    updateCheck() {
      for (const [key, value] of Object.entries(this.ophthalmic)) {
        if (value) {
          document.getElementById(key).click()
        }
      }
    },
    doCheck(item) {
      for (const key of Object.keys(this.ophthalmic)) {
        if (key == item.value) {
          this.ophthalmic[key] = item.checked // eslint-disable-line vue/no-mutating-props
        }
      }
    }
  }
}
</script>
